import { translate } from "../../util/translate"

export const announcementHeaders = [
  {
    text: translate['announcement.label.list.createdAt'],
    value: 'created_at',
    width: '100',
  },
  {
    text: translate['announcement.label.list.releaseDate'],
    value: 'release_date',
    width: '100',
  },
  {
    text: translate['announcement.label.list.type'],
    value: 'type',
    width: '100',
  },
  {
    text: translate['announcement.label.list.title'],
    value: 'title',
    width: '25',
  },
  { value: 'actions', align: 'end', width: '25' },
]
